/* eslint-disable no-return-assign */
import React, { Fragment } from "react";
import { Link } from "react-router";
import Swipeable from "react-swipeable";
import OddConverter from "@common/helpers/oddConverter";
import Config from "../../../../dev/config/main";
import HorizontalLoader from "../../../../dev/components/horizontalLoader";
import Loader from "../../components/loader";
import Expandable from "../../containers/expandable";
import MoneyAmount from "../../components/moneyAmount";
import { t } from "../../../../dev/helpers/translator";
import Keyboard from "../../components/virtualKeyboard";
import InfoBlock from "../../components/infoBlock";
import BetCoLacky from "../betCoLacky";
import BetIdEnter from "./EnterBetId";
import {
	BetslipTypesUSA,
	doBetSlipViewCalculations,
	BetslipTypes,
	BETSLIP_TYPE_SINGLE,
	BETSLIP_TYPE_SYSTEM,
	BETSLIP_TYPE_CHAIN,
	calculateSystemPossibleWin,
} from "../../../../dev/helpers/sport/betslip";
import Draggable from "react-draggable";
import StaticStake from "../staticStake";
import { bookIdCheck } from "../../../helpers/copyBetFunctional";
import Helpers from "../../../helpers/helperFunctions";
import ExpressBonus from "../expressBonus";
import CountDown from "../countdownHook";
import BetslipBaseDropdown from "../betslip/betslipBaseDropdown";
import { BetPriceChangeEnum } from "../../../constants/enums/betPriceChange";
import ToggleSwitch from "../toggleSwitch";

const horseRacingTypesMap = {
	40: "Straight Forecast",
	41: "Reverse Forecast",
	42: "Combination Forecast",
	43: "Straight Tricast",
	44: "Combination Tricast",
};

const tricastForcastSelectionListMap = {
	1: "1st",
	2: "2nd",
	3: "3rd",
	"1,2": "1st or 2nd",
	"1,2,3": "1st or 2nd or 3rd",
};

const getAdditionalMessage = option => {
	if (option.link) {
		return <p>{option.message && <span>{t(option.message)}</span>}</p>;
	}
	return <p dangerouslySetInnerHTML={{ __html: option.message || t("Insufficient balance") }} />;
};

export default function betslipTemplate() {
	let betSlip = this.props.betslip,
		hasSPEvent = Object.values(betSlip.events).some(el => el.horseType === "SP"),
		isPartnerIntegration = Config.isPartnerIntegration && Config.isPartnerIntegration.mode.iframe,
		betslipOdd,
		sysOptionValue = this.props.betslip.sysOptionValue,
		loggedIn = this.props.user.loggedIn,
		isAsian = sessionStorage.getItem("asianData")
			? JSON.parse(sessionStorage.getItem("asianData")).asian
			: Config.terminal.asianViewEnabled,
		enableCloseButton =
			isAsian ||
			this.props.pathname === "/" ||
			this.props.pathname === "/virtualGames" ||
			this.props.pathname === "/realHorseRacing",
		enableBetslipExpandable = Config.betslipExpandableIcon && this.props.pathname === "/",
		currency = JSON.parse(sessionStorage.getItem("authData")).currency;

	let {
		events,
		info,
		posWin,
		expOdds,
		expBonus,
		freeBetAvailable,
		totalStake,
		priceChangeNeeds2bConfirmed,
		betsCannotBePlaced,
		betsCannotBeBooked,
		displayInfo,
		systemOptions,
		insufficientBalance,
		horseBetSlipLocalTypes,
	} = doBetSlipViewCalculations(
		betSlip,
		this.props.data,
		this.props.user,
		this.props.currency,
		this.props.dispatch,
		this.props.terminal,
		this.props.terminalBalance,
		this.props.betslip.superBet,
		this.props.ui.oddsFormat,
		this.props.partnerConfig,
		this.props.tax?.taxPercent
	);

	systemOptions &&
		systemOptions.props.children.forEach(option => {
			if (sysOptionValue === +option.key) {
				betslipOdd = option.props.children;
			}
		});

	const hasBonus = this.props.terminal.bonuses && this.props.terminal.bonuses[0];
	const isBetslipEmpty = _.isEmpty(this.props.betslip.events);
	const isBetslipTypeSingle = betSlip.type === BETSLIP_TYPE_SINGLE;

	const { profile } = this.props.user;
	const userBalance = profile?.balance;
	const balance = JSON.parse(sessionStorage.getItem("balance"))?.session_balance;

	const finalBalance = +(
		(userBalance === undefined ? null : userBalance + "") ||
		(this.props.terminalBalance !== undefined
			? this.props.terminalBalance !== null
				? this.props.terminalBalance
				: balance === null
				? 0
				: balance
			: balance === null
			? 0
			: balance)
	);
	const bookingOnlyWithoutBalance = !Config.betting.bookingEnabledOnlyWithoutBalance || !finalBalance;

	// const posWinWithTax = parseFloat((posWin - ((posWin * this.props.tax?.taxPercent) / 100)).toFixed(2))
	let posWinWithTax = posWin;

	if (this.props.tax?.taxPercent) {
		posWinWithTax =
			betSlip.type === BETSLIP_TYPE_SINGLE
				? posWin - (posWin * this.props.tax?.taxPercent) / 100
				: parseFloat(
						betSlip.stake -
							((betSlip.stake * this.props.tax?.taxPercent) / 100).toFixed(2)
				  ) * (expOdds || 1);
	}

	const totalStakeWithoutTax =
		(betSlip.type === BETSLIP_TYPE_SINGLE ? betSlip.unitStake : betSlip.stake) *
		(1 - this.props.tax?.taxPercent / 100);

	const currencyType = currency || this.props.user?.profile?.currency_id;
	const selectedCurrencyConfig = (currencyType && this.props.currencyConfig?.[currencyType]) || {
		rounding: Config.main.currencyRounding,
	};
	const systemPossibleWin = calculateSystemPossibleWin(
		events,
		sysOptionValue,
		parseFloat(parseFloat(totalStakeWithoutTax).toFixed(Math.abs(selectedCurrencyConfig.rounding))),
		betSlip.bankerBetsCount,
		betSlip.eachWayMode
	)?.win;
	const returnTax = Helpers.calculateTaxForReturnedAndProfit(
		this.props.tax?.taxPercent,
		(betSlip.type === BETSLIP_TYPE_SYSTEM ? systemPossibleWin : posWinWithTax) + (expBonus || 0),
		this.props.partnerConfig?.tax_amount_ranges || null
	);

	const isRacingType = betSlip.type >= 40;

	return (
		<div
			onClick={e => {
				this.props.ui.showVirtualKeyBoard && !e.defaultPrevented && this.hideKeyboard();
				e.stopPropagation();
				this.props.ui.opened.settingsBets && this.props.uiClose("settingsBets")();
				this.props.ui.opened.betslipTypes && this.props.uiClose("betslipTypes")();
				this.props.ui.opened.betslipOdd && this.props.uiClose("betslipOdd")();
			}}
			className={`${
				events.length >= 3 && BetslipTypes[betSlip.type] === "System" ? "systemDropDown " : ""
			} ${"betslip-m " + BetslipTypes[betSlip.type]} ${loggedIn ? " logged-in" : " logged-out"} ${
				betSlip.quickBet ? " quick" : ""
			} ${this.props.ui.loading.bet ? " loading" : ""} ${
				this.props.disableBetslip ? "" : " disableBetslip"
			} ${this.props.pathname === "/" ? "betslip-home" : ""} ${
				isBetslipEmpty ? "betslip-empty" : ""
			} ${this.props.className}`}
		>
			<Draggable
				axis="both"
				handle=".betslip-balance-view-m"
				defaultPosition={{ x: 0, y: 0 }}
				position={null}
				bounds=".terminal-wrapper"
				onDrag={this.handleDrag}
				onStop={this.draggedStop}
				disabled={!Config.enableDraggable}
				grid={[1, 1]}
			>
				<div className="betslip-balance-view-m">
					<ul>
						{Config.main.enableBetHistoryInFooter && this.props.user.profile ? (
							<li>
								<Link to="/history/open-bets">Bet History</Link>
							</li>
						) : null}
						{betSlip.quickBet ? (
							<li>
								{this.props.ui.loading.bet ? (
									<p>
										{t("Making quick bet...")}
										<HorizontalLoader />
									</p>
								) : (
									<p>{t("Quick bet mode")}</p>
								)}
							</li>
						) : (
							<li onClick={this.openBetslip}>
								<span className="betslip-title-mini">
									<b>{events.length}</b>
									<i>{t("Betslip")}</i>
								</span>
							</li>
						)}
					</ul>
				</div>
			</Draggable>
			<div
				className={
					"betslip-full-view" +
					(this.props.ui.opened.betslip ? " active" : "") +
					(this.props.pathname === "/virtualGames" ? " betslip-for-virtualGames" : "") +
					(this.props.pathname.includes("/thirdPartyGame") ? " remove-betslip" : "") +
					(this.state.betslipCollapsed ? " betslip-collapsed" : "") +
					(this.props.pathname.includes("/prematch") ? " day-filter" : "")
				}
			>
				<Swipeable className="betslip-header-m">
					<div className="quick-bet-settings-view">
						{enableCloseButton && (
							<div
								className="closed-betslip-icon"
								onClick={this.openBetslip}
							/>
						)}
						<h3
							onClick={() => {
								this.lucky.setAttribute("style", "display: none;");
								this.betslipContainer.setAttribute(
									"style",
									"display: block;"
								);
							}}
						>
							{t("Betslip")}
						</h3>{" "}
						{/** TO DO */}
						{Config.main.enableBetCoLucky && (
							<h3
								className="lucky"
								onClick={() => {
									this.lucky.setAttribute(
										"style",
										"display: block;"
									);
									this.betslipContainer.setAttribute(
										"style",
										"display: none;"
									);
								}}
							>
								{t("Betcolucky")}
							</h3>
						)}{" "}
						{/** TO DO */}
						{/* <h3>{t("Betslip")}</h3> */}
						{Config.enableMarketCountInBetSlip &&
						Config.betTypesInOneLine &&
						betSlip.type !== BETSLIP_TYPE_SYSTEM &&
						Object.keys(betSlip.events).length !== 0 ? (
							<div className="market-count">
								<span className="round-selection-Count">
									{Object.keys(betSlip.events).length}
								</span>
							</div>
						) : null}
						<div
							className={`betslip-settings ${
								this.props.ui.opened.settingsBets ? "open" : ""
							}`}
							onClick={this.betslipHandleClicks("settingsBets")}
						/>
						{enableBetslipExpandable && (
							<i
								className={`expandable-betslip-icon${
									this.state.betslipCollapsed ? " collapsed" : ""
								}`}
								onClick={this.toggleExpandBetslip}
							/>
						)}
						<div className="b-settings-view-b">
							<ul>
								<li>
									<p>{t("When price changes:")}</p>
								</li>
								<li>
									<div
										className={`radio-form-item ${
											betSlip.acceptPriceChanges ===
											BetPriceChangeEnum.AlwaysAsk
												? "active"
												: ""
										}`}
									>
										<label>
											<input
												type="radio"
												name="odd-settings"
												onClick={() =>
													this.setBetslipSettings(
														BetPriceChangeEnum.AlwaysAsk
													)
												}
											/>
											<span>{t("Always ask")}</span>
										</label>
									</div>
								</li>
								<li>
									<div
										className={`radio-form-item ${
											betSlip.acceptPriceChanges ===
											BetPriceChangeEnum.AcceptHigherOdds
												? "active"
												: ""
										}`}
									>
										<label>
											<input
												type="radio"
												name="odd-settings"
												checked={
													betSlip.acceptPriceChanges ===
													BetPriceChangeEnum.AcceptHigherOdds
												}
												onClick={() =>
													this.setBetslipSettings(
														BetPriceChangeEnum.AcceptHigherOdds
													)
												}
											/>
											<span>
												{t(
													"Accept higher odds"
												)}
											</span>
										</label>
									</div>
								</li>
								<li>
									<div
										className={`radio-form-item ${
											betSlip.acceptPriceChanges ===
											BetPriceChangeEnum.AcceptAnyOdds
												? "active"
												: ""
										}`}
									>
										<label>
											<input
												type="radio"
												name="odd-settings"
												checked={
													Config.main
														.setDefaultBetSlipSettingType
														? true
														: betSlip.acceptPriceChanges ===
														  BetPriceChangeEnum.AcceptAnyOdds
												}
												onClick={() =>
													this.setBetslipSettings(
														BetPriceChangeEnum.AcceptAnyOdds
													)
												}
											/>
											<span>
												{t("Accept any odds")}
											</span>
										</label>
									</div>
								</li>
							</ul>
						</div>
					</div>

					{!betSlip.quickBet ? (
						<div className="all-bets-settings-row-m">
							{Config.enableMarketCountInBetSlip &&
							!Config.betTypesInOneLine &&
							betSlip.type !== BETSLIP_TYPE_SYSTEM &&
							Object.keys(betSlip.events).length !== 0 ? (
								<div className="market-count">
									<span className="round-selection-Count">
										{Object.keys(betSlip.events).length}
									</span>
								</div>
							) : null}
							<ul>
								{isRacingType &&
								horseRacingTypesMap[
									horseBetSlipLocalTypes.localBetslipHorseType
								] ? (
									<li>
										<p>
											{t(
												horseRacingTypesMap[
													horseBetSlipLocalTypes
														.localBetslipHorseType
												]
											)}
										</p>
									</li>
								) : (
									<li>
										{!Config.betTypesInOneLine ? (
											<div
												className={`dropdown-view-w-t ${
													this.props.ui
														.opened
														.betslipTypes &&
													"active"
												}`}
												onClick={this.betslipHandleClicks(
													"betslipTypes"
												)}
											>
												<p>
													{t(
														BetslipTypes[
															betSlip
																.type
														]
													)}
												</p>
												{isRacingType && (
													<p>
														{t(
															horseBetSlipLocalTypes.localBetslipHorseType
														)}
													</p>
												)}
												<div className="open-d-w-t">
													<ul
														onClick={this.betslipHandleClicks(
															"betslipTypes"
														)}
													>
														{Object.keys(
															BetslipTypes
														).map(
															type => (
																<li
																	key={
																		type
																	}
																	onClick={this.setBetslipType(
																		type
																	)}
																	className={`${
																		this
																			.props
																			.betslip
																			.type ===
																			+type &&
																		"active"
																	}`}
																>
																	{t(
																		BetslipTypes[
																			type
																		]
																	)}
																</li>
															)
														)}
													</ul>
												</div>
											</div>
										) : (
											<div className="one-line-betslip">
												<div
													onClick={this.betslipHandleClicks(
														"betslipTypes"
													)}
													className="radio-form-item"
												>
													{Object.keys(
														BetslipTypes
													).map(type => (
														<label
															className={`betslip-type ${
																this
																	.props
																	.betslip
																	.type ===
																+type
																	? "active"
																	: ""
															}`}
															key={
																type
															}
														>
															<input
																type="radio"
																checked={
																	this
																		.props
																		.betslip
																		.type ===
																	+type
																}
																value={
																	Config.enableUSABetslipType
																		? BetslipTypesUSA[
																				type
																		  ]
																		: BetslipTypes[
																				type
																		  ]
																}
																onChange={this.setBetslipType(
																	type
																)}
															/>
															<span>
																{t(
																	Config.enableUSABetslipType
																		? BetslipTypesUSA[
																				type
																		  ]
																		: BetslipTypes[
																				type
																		  ]
																)}
															</span>
														</label>
													))}
												</div>
											</div>
										)}
									</li>
								)}

								{systemOptions && !Config.systemOptionsOnFooter ? (
									<li className="system-select-option">
										<div
											className={`dropdown-view-w-t ${
												this.props.ui.opened
													.betslipOdd &&
												"active"
											}`}
											onClick={this.betslipHandleClicks(
												"betslipOdd"
											)}
										>
											<p>{betslipOdd}</p>
											<div className="open-d-w-t">
												{systemOptions}
											</div>
										</div>
									</li>
								) : null}

								{events.length > Config.eventsCountToShowBetslipClear &&
								!Config.betslipClearAllButtonOnFooter ? (
									<li className="cleared-all-box">
										<div
											className="clear-all-m"
											onClick={this.clearBetslip}
										>
											<span />
										</div>
									</li>
								) : null}
							</ul>
							{/* <FreeBetBonus
                    events={betSlip.events}
                    type={betSlip.type}
                    loggedIn={loggedIn}
                    acceptPriceChanges={betSlip.acceptPriceChanges}
                /> */}
						</div>
					) : null}
				</Swipeable>
				{Config.betting.enableCounterOffer &&
					betSlip.type === BETSLIP_TYPE_SINGLE &&
					!!events.length && (
						<div className="toggle-switch-wrap">
							<ToggleSwitch
								checked={
									betSlip.acceptPriceChanges ===
									BetPriceChangeEnum.CounterOffer
								}
								onChange={e =>
									e.target.checked
										? this.setBetslipSettings(
												BetPriceChangeEnum.CounterOffer
										  )
										: this.setBetslipSettings()
								}
							/>
							<div className="counter-offer-title">
								{t("Counter offer checker")}
							</div>
							<InfoBlock
								info={t(
									"Counter Offer is a new option that allows suggesting preferable odds for selected sporting events."
								)}
							/>
						</div>
					)}
				<BetCoLacky
					dispatch={this.props.dispatch}
					toggleToBetSlip={() => {
						this.lucky.setAttribute("style", "display: none;");
						this.betslipContainer.setAttribute("style", "display: block;");
					}}
					deepRef={el => (this.lucky = el)}
				/>
				{isBetslipEmpty && (
					<div className="empty-container">
						<i className="global-icon icon-empty-betslip" />
						{t("Please add some event(s) to the betslip to be able to place a bet")}
					</div>
				)}
				{!betSlip.quickBet ? (
					<div
						className="betslip-events-container"
						ref={el => (this.betslipContainer = el)}
					>
						{(() => {
							return this.props.ui.showVirtualKeyBoard ? (
								<Keyboard
									settings={this.keyboardSettings}
									bindToElement={false}
									betSlipType={betSlip.type}
								/>
							) : null;
						})()}
						{events.map(bet => (
							<div
								ref={bet.order}
								key={bet.eventId}
								onClick={() => this.setActiveEvent(bet.eventId)}
								className={
									"single-event-contain-m" +
									(isBetslipTypeSingle &&
									bet.eventId === betSlip.activeEventId
										? " active"
										: "") +
									(!bet.available ? " deleted" : "")
								}
							>
								<div
									className={`team-name-view-b-m ${
										Config.enableBetslipLiveIcon &&
										bet.isLive &&
										"liveEvent"
									}`}
								>
									{bet.isBoosted && (
										<i className="global-icon icon-boosted"></i>
									)}
									{(betSlip.betFailed?.selectionId &&
										+bet.eventId ===
											+betSlip.betFailed
												.selectionId) ||
									(!isBetslipTypeSingle &&
										bet.marketDisplayKey === "OUTRIGHT" &&
										info.hasSingleOnlyEvents) ? (
										<b className="icon-status-view-m event-error" />
									) : null}
									{bet.blocked
										? [
												<Expandable
													key={bet.order}
													className="icon-status-view-m event-blocked"
													uiKey={
														"bttBlocked" +
														bet.order
													}
													ref={bet.order}
												/>,
												<div
													key={
														bet.eventId
													}
													className="sub-error-info"
												>
													<p>
														{t(
															"Event is blocked."
														)}
													</p>
												</div>,
										  ]
										: null}
									{!bet.available
										? [
												<Expandable
													key={bet.order}
													className={`icon-status-view-m ${
														bet.deleted
															? "event-deleted"
															: "event-loading"
													}`}
													uiKey={
														"bttUnavailable" +
														bet.order
													}
													ref={bet.order}
												/>,
												<div
													key={
														bet.eventId
													}
													className="sub-error-info"
												>
													<p>
														{t(
															"Event is not available."
														)}
													</p>
												</div>,
										  ]
										: null}
									{Config.main.enableLinkInBetslip &&
									bet.gameType !== 0 ? (
										<Link
											to={`/${
												bet.gameType !== 1
													? "prematch"
													: "live"
											}/${bet.sportAlias}/${
												bet.regionId
											}/${bet.competitionId}/${
												bet.gameId
											}`}
										>
											<b>{bet.title}</b>
										</Link>
									) : (
										<b>{bet.title}</b>
									)}
									<button
										className="event-remove-b-m"
										onClick={this.removeFromBetslip(
											bet.eventId
										)}
									/>
								</div>

								<div className="market-full-info-m">
									<ul>
										{bet.marketName && (
											<li>
												<p className="betmarket-name-m">
													{t(
														bet.marketName
													)}
												</p>
											</li>
										)}
										{!Config.showPriceUpdateDirection &&
										bet.price &&
										bet.initialPrice !== bet.price &&
										!(
											betSlip.horseEvents[
												bet.eventId
											] &&
											betSlip.horseEvents[bet.eventId]
												.type !== "PRICE"
										) ? (
											<li>
												<span className="change-price-m">
													{OddConverter(
														bet.initialPrice,
														this
															.props
															.ui
															.oddsFormat
													)}
												</span>
											</li>
										) : null}
									</ul>
									<ul>
										<li>
											<p className="bet-pick-name-m">
												{" "}
												{Config.enableBaseDropDown &&
												Config.selectMarketTypeInDropdown.includes(
													bet.marketDisplayKey
												) ? (
													<BetslipBaseDropdown
														bet={
															bet
														}
													/>
												) : (
													<>
														{
															bet.pick
														}{" "}
														{
															bet.base
														}
													</>
												)}
											</p>
										</li>
										<li>
											<span className="price-view-m">
												{Config.showPriceUpdateDirection &&
													bet.price &&
													bet.initialPrice !==
														bet.price &&
													!(
														betSlip
															.horseEvents[
															bet
																.eventId
														] &&
														betSlip
															.horseEvents[
															bet
																.eventId
														]
															.type !==
															"PRICE"
													) && (
														<i
															class={`${
																bet.price >
																BetIdEnter.initialPrice
																	? "top-m"
																	: "bot-m"
															}`}
														/>
													)}
												{bet.horseType ===
												"PRICE"
													? OddConverter(
															bet.price,
															this
																.props
																.ui
																.oddsFormat
													  )
													: bet.horseType ===
													  "SP"
													? t("SP")
													: bet.forecastOrTricastTypeOrderArray
													? t(
															tricastForcastSelectionListMap[
																bet
																	.forecastOrTricastTypeOrderArray
															]
													  )
													: OddConverter(
															bet.price,
															this
																.props
																.ui
																.oddsFormat
													  ) ||
													  OddConverter(
															bet.initialPrice,
															this
																.props
																.ui
																.oddsFormat
													  )}
											</span>
										</li>
									</ul>
								</div>
								{betSlip.type === BETSLIP_TYPE_SINGLE ? (
									<div className="single-bet-m">
										<div className="stake-form-b-m">
											<ul>
												{betSlip.eachWayMode ? (
													<li>
														<div className="mini-table-b-m">
															<ul>
																<li>
																	<div className="single-form-item">
																		{betSlip.freeBet ? null : (
																			<span
																				onClick={e => {
																					if (
																						!this
																							.props
																							.ui
																							.showVirtualKeyBoard &&
																						!betSlip.freeBet
																					) {
																						this.scrollBetSlipToElement(
																							e
																						);
																						this.openKeyBoard(
																							bet.singleUnitStake,
																							this.setUnitStake(
																								bet
																							),
																							null,
																							bet,
																							e
																						);
																					}
																				}}
																			>
																				{betSlip.stake
																					? betSlip.stake /
																					  2
																					: t(
																							"Stake"
																					  )}
																			</span>
																		)}
																	</div>
																</li>
															</ul>
														</div>
													</li>
												) : null}
												<li>
													<div className="mini-table-b-m">
														<ul>
															<li>
																{Config
																	.betting
																	.enableCounterOffer &&
																	betSlip.acceptPriceChanges ===
																		BetPriceChangeEnum.CounterOffer && (
																		<div className="single-form-item-wrap">
																			<div className="single-form-item">
																				<span
																					onClick={e => {
																						if (
																							!this
																								.props
																								.ui
																								.showVirtualKeyBoard &&
																							!betSlip.freeBet
																						) {
																							this.scrollBetSlipToElement(
																								e
																							);
																							this.openKeyBoard(
																								bet.offeredPrice ||
																									"",
																								this.setOfferedPrice(
																									bet
																								),
																								null,
																								bet,
																								e
																							);
																						}
																					}}
																				>
																					{bet.offeredPrice
																						? bet.offeredPrice
																						: t(
																								"Your offer"
																						  )}
																				</span>
																			</div>
																			{bet.maxOddToOffer && (
																				<div
																					className="betslip-max-odd-button"
																					onClick={() =>
																						this.setOfferedPrice(
																							bet
																						)(
																							OddConverter(
																								bet.maxOddToOffer,
																								this
																									.props
																									.ui
																									.oddsFormat
																							)
																						)
																					}
																				>
																					{t(
																						"Max"
																					)}{" "}
																					{OddConverter(
																						bet.maxOddToOffer,
																						this
																							.props
																							.ui
																							.oddsFormat
																					)}
																				</div>
																			)}
																		</div>
																	)}
																<div className="single-form-item">
																	{betSlip.freeBet ? null : (
																		<span
																			onClick={e => {
																				if (
																					!this
																						.props
																						.ui
																						.showVirtualKeyBoard &&
																					!betSlip.freeBet
																				) {
																					this.scrollBetSlipToElement(
																						e
																					);
																					this.openKeyBoard(
																						bet.singleStake,
																						this.setStake(
																							bet
																						),
																						null,
																						bet,
																						e
																					);
																				}
																			}}
																		>
																			{bet.singleStake
																				? bet.singleStake
																				: t(
																						"Stake..."
																				  )}
																		</span>
																	)}
																	{Config
																		.main
																		.enableSetSameStake &&
																		bet.eventId ===
																			betSlip.activeEventId &&
																		bet.singleStake &&
																		events.length >
																			1 && (
																			<div
																				className="use-for-all"
																				onClick={this.setSameStakeOnOtherEvents(
																					bet
																				)}
																			>
																				{t(
																					"Use for all"
																				)}
																			</div>
																		)}
																	{Config
																		.main
																		.enableSetSameStakeForNext &&
																		bet.eventId ===
																			betSlip.activeEventId &&
																		bet.singleStake &&
																		events.length >
																			1 && (
																			<div
																				className="use-for-all"
																				onClick={this.setSameStakeOnNextEvents(
																					bet
																				)}
																			>
																				{t(
																					"Use for all"
																				)}
																			</div>
																		)}
																</div>
															</li>

															{!betSlip.freeBet &&
															betSlip.type !==
																BETSLIP_TYPE_CHAIN &&
															!Config.turnOffMaxBetButton ? (
																<li
																	className={`staticStakeMax ${
																		this
																			.props
																			.ui
																			.loading
																			.getMaxBet
																			? "disabled"
																			: ""
																	}`}
																	onClick={() => {
																		!betSlip.freeBet &&
																			this.getMaxStake(
																				bet,
																				horseBetSlipLocalTypes.localBetslipHorseType
																			)();
																	}}
																>
																	<div className="max-bet-b-m">
																		<span>
																			{t(
																				"Max bet"
																			)}
																		</span>
																	</div>
																</li>
															) : null}
														</ul>
													</div>
												</li>
												{/* {events.length > 1 && Config.main.enableSetSameStake && betIndex === 0
                                            ? <li onClick={this.setSameStakeOnOtherEvents(bet)}>
                                                <div className="bet-price-button-m" />
                                            </li> : null} */}
											</ul>
										</div>
									</div>
								) : null}
							</div>
						))}
						<div className="b-s-contain">
							{systemOptions && Config.systemOptionsOnFooter ? (
								<li className="system-select-option">
									<div className="quantity-of-variants">
										{t("Quantity of Variants")}:{" "}
										{systemOptions.props.children.length}
									</div>
									<div
										className={`dropdown-view-w-t ${
											this.props.ui.opened
												.betslipOdd && "active"
										}`}
										onClick={this.betslipHandleClicks(
											"betslipOdd"
										)}
									>
										<p>{betslipOdd}</p>
										<div className="open-d-w-t">
											{systemOptions}
										</div>
									</div>
								</li>
							) : null}

							{events.length ? (
								<div className="total-view-price-pos-b">
									<div className="ew-total-odd">
										<ul>
											<li>
												{hasBonus &&
													Config.betting
														.enableExpressBonus && (
														<ExpressBonus
															stake={
																betSlip.stake
															}
															events={
																events
															}
															posWin={
																posWinWithTax
															}
															expBonus={
																expBonus
															}
														/>
													)}
											</li>
											{info.hasEachWayReadyEvents ? (
												<li>
													<label className="ew-view-b">
														<input
															type="checkbox"
															defaultChecked={
																betSlip.eachWayMode
															}
															onChange={
																this
																	.toggleEachWayMode
															}
														/>
														<span>
															{t(
																"EW"
															)}
														</span>
													</label>
												</li>
											) : null}
											{expOdds || expOdds === 0 ? (
												<li>
													<p>
														{t(
															"Odds"
														)}
														<span>
															{OddConverter(
																expOdds ||
																	0,
																this
																	.props
																	.ui
																	.oddsFormat
															)}
														</span>
													</p>
												</li>
											) : null}
										</ul>
									</div>

									{hasBonus &&
										events.length >=
											this.props.terminal.bonuses[0]
												.MinimumSelections -
												1 &&
										events.filter(
											item =>
												item.price >=
												this.props.terminal
													.bonuses[0]
													.MinOdds
										).length ===
											this.props.terminal.bonuses[0]
												.MinimumSelections -
												1 && (
											<div className="bonus-message">
												<span>
													{" "}
													{t(
														"You can get additional {1}% bonus if you add 1 more selection only with min odd {2} and over",
														this
															.props
															.terminal
															.bonuses[0]
															.AmountPercent,
														this
															.props
															.terminal
															.bonuses[0]
															.MinOdds
													)}
												</span>
											</div>
										)}
									<div className="stake-form-b-m">
										{betSlip.type !== BETSLIP_TYPE_SINGLE &&
										!(
											freeBetAvailable &&
											betSlip.freeBet
										) ? (
											<ul>
												<li>
													<div className="mini-table-b-m">
														<ul>
															{betSlip.type ===
																BETSLIP_TYPE_SYSTEM &&
															events.length >
																2 ? (
																<li>
																	<div className="single-form-item">
																		{/* eslint-disable-next-line react/jsx-no-bind*/}
																		<span
																			className={
																				betSlip.activeInput ===
																				"unit"
																					? "system-active-input"
																					: ""
																			}
																			onClick={e => {
																				if (
																					!this
																						.props
																						.ui
																						.showVirtualKeyBoard &&
																					!betSlip.freeBet
																				) {
																					this.scrollBetSlipToElement(
																						e
																					);
																					this.openKeyBoard(
																						betSlip.unitStake,
																						this.setUnitStake(),
																						null,
																						betSlip,
																						e,
																						() =>
																							this.setSystemActiveInput(
																								null
																							)
																					);
																					this.setSystemActiveInput(
																						"unit"
																					);
																				}
																			}}
																		>
																			{betSlip.unitStake ||
																				t(
																					"Unit amount:"
																				)}
																		</span>
																	</div>
																</li>
															) : null}
															<li>
																<div className="single-form-item">
																	{/* eslint-disable-next-line react/jsx-no-bind*/}
																	<span
																		className={
																			(betSlip.activeInput ===
																			"total"
																				? "system-active-input"
																				: "") +
																			(Config
																				.betting
																				.enableSuperBet &&
																			!Config
																				.betting
																				.enableSuperBetAutomatically &&
																			Config.superBetAfterStakeInput
																				? " superbet"
																				: "")
																		}
																		onClick={e => {
																			if (
																				!this
																					.props
																					.ui
																					.showVirtualKeyBoard &&
																				!betSlip.freeBet
																			) {
																				this.scrollBetSlipToElement(
																					e
																				);
																				this.openKeyBoard(
																					betSlip.stake.toString(),
																					this.setStake(),
																					null,
																					betSlip,
																					e,
																					() =>
																						this.setSystemActiveInput(
																							null
																						)
																				);
																				this.setSystemActiveInput(
																					"total"
																				);
																			}
																		}}
																	>
																		{betSlip.stake ||
																			t(
																				betSlip.type ===
																					BETSLIP_TYPE_SYSTEM
																					? "Total amount:"
																					: "Stake:"
																			)}
																	</span>
																	{Config
																		.betting
																		.enableSuperBet &&
																	!Config
																		.betting
																		.enableSuperBetAutomatically &&
																	Config.superBetAfterStakeInput &&
																	(Config
																		.betting
																		.allowSuperBetForLive ||
																		(Object.keys(
																			this
																				.props
																				.betslip
																				.events
																		)
																			.length !==
																			0 &&
																			!Helpers.hasLiveGame(
																				Object.values(
																					this
																						.props
																						.betslip
																						.events
																				)
																			))) ? (
																		<div className="separator-box-buttons-m superbet ahah">
																			<label
																				htmlFor="superbet"
																				className="multi-column-mode-toggle"
																			>
																				<input
																					id="superbet"
																					style={{
																						position: "relative",
																						left: 0,
																						top: 0,
																					}}
																					type="checkbox"
																					onClick={
																						this
																							.toggleSuperBet
																					}
																					checked={
																						(Config
																							.betting
																							.allowSuperBetForLive ||
																							!Helpers.hasLiveGame(
																								Object.values(
																									this
																										.props
																										.betslip
																										.events
																								)
																							)) &&
																						!!this
																							.props
																							.betslip
																							.superBet
																					}
																				/>
																				<p>
																					Superbet
																					is{" "}
																					{this
																						.props
																						.betslip
																						.superBet
																						? "on"
																						: "off"}
																				</p>
																			</label>
																		</div>
																	) : null}
																</div>
															</li>

															{events.length &&
															betSlip.type !==
																BETSLIP_TYPE_SYSTEM &&
															betSlip.type !==
																BETSLIP_TYPE_CHAIN &&
															!Config.turnOffMaxBetButton ? (
																<li
																	className={`staticStakeMax ${
																		this
																			.props
																			.ui
																			.loading
																			.getMaxBet
																			? "disabled"
																			: ""
																	} ${
																		Config
																			.betting
																			.enableSuperBet &&
																		!Config
																			.betting
																			.enableSuperBetAutomatically &&
																		Config.superBetAfterStakeInput
																			? "superbet"
																			: ""
																	}`}
																	onClick={this.getMaxStake(
																		events,
																		horseBetSlipLocalTypes.localBetslipHorseType
																	)}
																>
																	<div className="max-bet-b-m">
																		<span>
																			{t(
																				"Max bet"
																			)}
																		</span>
																	</div>
																</li>
															) : null}
														</ul>
													</div>
												</li>
											</ul>
										) : null}
									</div>

									{Config.staticStake && (
										<StaticStake
											ref={staticState =>
												(this.staticState =
													staticState)
											} // TO DO
											setStake={this.setStake()}
											activeStake={
												betSlip.activeEventId &&
												betSlip.type ===
													BETSLIP_TYPE_SINGLE
													? betSlip
															.events[
															betSlip
																.activeEventId
													  ]?.singleStake
													: betSlip.stake
											}
											currency={currency}
											events={events}
											betSlip={betSlip}
											user={this.props.user}
											terminalBalance={
												this.props
													.terminalBalance
											}
										/>
									)}
									{posWin > 0 ? (
										<div className="possible-win-container">
											{this.props.tax &&
											_.isNumber(
												this.props.tax
													.taxPercent
											) &&
											(this.props.tax
												.taxIntegrationType ===
												0 ||
												this.props.tax
													.taxIntegrationType ===
													2)
												? function () {
														switch (
															this
																.props
																.tax
																.taxType
														) {
															case 1: //Profit tax
																return [
																	<ul key="11">
																		<li>
																			<p className="possible-text-title-m">
																				{t(
																					"Total stake:"
																				)}
																			</p>
																		</li>
																		<li>
																			<span className="sum-bet-win-price-m">
																				<MoneyAmount
																					amount={
																						betSlip.freeBet
																							? Number.parseFloat(
																									betSlip.selectedFreeBetAmount
																							  ) ||
																							  0
																							: betSlip.type ===
																							  BETSLIP_TYPE_SINGLE
																							? betSlip.unitStake
																							: betSlip.stake
																					}
																				/>
																			</span>
																		</li>
																	</ul>,
																	<ul key="12">
																		<li>
																			<p className="possible-text-title-m">
																				{t(
																					"Possible win:"
																				)}
																			</p>
																		</li>
																		<li>
																			<span className="sum-bet-win-price-m">
																				<MoneyAmount
																					amount={
																						posWin
																					}
																				/>
																			</span>
																		</li>
																	</ul>,
																	<Fragment key="13">
																		{Config.TaxInParts ? (
																			<Fragment>
																				<ul>
																					<li>
																						<p className="possible-text-title-m">
																							{t(
																								"State Withholding Tax:"
																							)}
																						</p>
																					</li>
																					<li>
																						<span className="sum-bet-win-price-m">
																							<MoneyAmount
																								amount={
																									Helpers.calculateTaxForReturnedAndProfit(
																										this
																											.props
																											.tax
																											.taxPercent,
																										posWin +
																											expBonus -
																											(betSlip.type ===
																											BETSLIP_TYPE_SINGLE
																												? betSlip.unitStake
																												: betSlip.stake),
																										this
																											.props
																											.partnerConfig
																											.tax_amount_ranges ||
																											null
																									) *
																									(6 /
																										7)
																								}
																							/>
																						</span>
																					</li>
																				</ul>
																				<ul>
																					<li>
																						<p className="possible-text-title-m">
																							{t(
																								"Federal Withholding Tax:"
																							)}
																						</p>
																					</li>
																					<li>
																						<span className="sum-bet-win-price-m">
																							<MoneyAmount
																								amount={
																									Helpers.calculateTaxForReturnedAndProfit(
																										this
																											.props
																											.tax
																											.taxPercent,
																										posWin +
																											expBonus -
																											(betSlip.type ===
																											BETSLIP_TYPE_SINGLE
																												? betSlip.unitStake
																												: betSlip.stake),
																										this
																											.props
																											.partnerConfig
																											.tax_amount_ranges ||
																											null
																									) *
																									(1 /
																										7)
																								}
																							/>
																						</span>
																					</li>
																				</ul>
																			</Fragment>
																		) : (
																			<Fragment>
																				<ul>
																					<li>
																						<p className="possible-text-title-m">
																							{t(
																								"Tax on Profit:"
																							)}
																						</p>
																					</li>
																					<li>
																						<span className="sum-bet-win-price-m">
																							<MoneyAmount
																								amount={Helpers.calculateTaxForReturnedAndProfit(
																									this
																										.props
																										.tax
																										.taxPercent,
																									posWin +
																										expBonus -
																										(betSlip.type ===
																										BETSLIP_TYPE_SINGLE
																											? betSlip.unitStake
																											: betSlip.stake),
																									this
																										.props
																										.partnerConfig
																										.tax_amount_ranges ||
																										null
																								)}
																							/>
																						</span>
																					</li>
																				</ul>
																			</Fragment>
																		)}
																	</Fragment>,
																	<ul key="14">
																		<li>
																			<p className="possible-text-title-m">
																				{t(
																					"Estimated return:"
																				)}
																			</p>
																		</li>
																		<li>
																			<span className="sum-bet-win-price-m">
																				<MoneyAmount
																					amount={
																						posWin -
																						Helpers.calculateTaxForReturnedAndProfit(
																							this
																								.props
																								.tax
																								?.taxPercent,
																							posWin +
																								expBonus -
																								(betSlip.type ===
																								BETSLIP_TYPE_SINGLE
																									? betSlip.unitStake
																									: betSlip.stake),
																							this
																								.props
																								.partnerConfig
																								?.tax_amount_ranges ||
																								null
																						)
																					}
																				/>
																			</span>
																		</li>
																	</ul>,
																	systemOptions &&
																		Config
																			.terminal
																			.showMinPossibleWin && (
																			<ul>
																				<li>
																					<p className="possible-text-title-m">
																						{"Min " +
																							t(
																								"possible win:"
																							)}
																					</p>
																				</li>
																				<li>
																					<span className="sum-bet-win-price-m">
																						{Config.enableCurrencyView && (
																							<span>
																								{
																									Config
																										.main
																										.currency[
																										currency
																									]
																								}
																							</span>
																						)}
																						{Math.trunc(
																							this.getSystemPossibleMin(
																								events,
																								sysOptionValue,
																								betSlip.unitStake
																							) *
																								(1 -
																									this
																										.props
																										.tax
																										.taxPercent /
																										100) *
																								1000
																						) /
																							1000}
																					</span>
																				</li>
																			</ul>
																		),
																];
															case 2: //Return tax
																return [
																	<ul key="7">
																		<li>
																			<p className="possible-text-title-m">
																				{t(
																					"Total stake:"
																				)}
																			</p>
																		</li>
																		<li>
																			<span className="sum-bet-win-price-m">
																				<MoneyAmount
																					amount={
																						betSlip.freeBet
																							? Number.parseFloat(
																									betSlip.selectedFreeBetAmount
																							  ) ||
																							  0
																							: betSlip.type ===
																							  BETSLIP_TYPE_SINGLE
																							? totalStake
																							: betSlip.stake
																					}
																				/>
																			</span>
																		</li>
																	</ul>,
																	<ul key="8">
																		<li>
																			<p className="possible-text-title-m">
																				{t(
																					"Possible win:"
																				)}
																			</p>
																		</li>
																		<li>
																			<span className="sum-bet-win-price-m">
																				<MoneyAmount
																					amount={
																						posWin
																					}
																				/>
																			</span>
																		</li>
																	</ul>,
																	<ul key="9">
																		{Config.swapTaxAndBonus ? (
																			expBonus ? (
																				<>
																					<li>
																						<p className="bonus-text-title-m">
																							{!Config.betslipTextsCircus
																								? t(
																										"Accumulator Bonus"
																								  )
																								: t(
																										"Boost"
																								  )}
																						</p>
																					</li>
																					<li>
																						<span className="bonus-bet-win-price-m">
																							<MoneyAmount
																								amount={
																									expBonus
																								}
																							/>
																						</span>
																					</li>
																				</>
																			) : null
																		) : (
																			<>
																				<li>
																					<p className="possible-text-title-m">
																						{t(
																							"Tax on Return:"
																						)}
																					</p>
																				</li>
																				<li>
																					<span className="sum-bet-win-price-m">
																						<MoneyAmount
																							amount={
																								returnTax
																							}
																						/>
																					</span>
																				</li>
																			</>
																		)}
																	</ul>,
																	<ul key="10">
																		<li>
																			<p className="possible-text-title-m">
																				{t(
																					"Estimated return:"
																				)}
																			</p>
																		</li>
																		<li>
																			<span className="sum-bet-win-price-m">
																				<MoneyAmount
																					amount={
																						Config.estimatedReturnAndTotalWinCalculationChange
																							? posWin +
																							  (expBonus ||
																									0)
																							: posWin -
																							  Helpers.calculateTaxForReturnedAndProfit(
																									this
																										.props
																										.tax
																										?.taxPercent,
																									posWin +
																										expBonus,
																									this
																										.props
																										.partnerConfig
																										?.tax_amount_ranges ||
																										null
																							  )
																					}
																				/>
																			</span>
																		</li>
																	</ul>,
																	systemOptions &&
																		Config
																			.terminal
																			.showMinPossibleWin && (
																			<ul>
																				<li>
																					<p className="possible-text-title-m">
																						{"Min " +
																							t(
																								"possible win:"
																							)}
																					</p>
																				</li>
																				<li>
																					<span className="sum-bet-win-price-m">
																						{Config.enableCurrencyView && (
																							<span>
																								{
																									Config
																										.main
																										.currency[
																										currency
																									]
																								}
																							</span>
																						)}
																						{Math.trunc(
																							this.getSystemPossibleMin(
																								events,
																								sysOptionValue,
																								betSlip.unitStake
																							) *
																								(1 -
																									this
																										.props
																										.tax
																										.taxPercent /
																										100) *
																								1000
																						) /
																							1000}
																					</span>
																				</li>
																			</ul>
																		),
																];
															case 4: //Stake tax
																return [
																	<ul key="1">
																		<li>
																			<p className="possible-text-title-m">
																				{t(
																					"Stake:"
																				)}
																			</p>
																		</li>
																		<li>
																			<span className="sum-bet-win-price-m">
																				{betSlip.type ===
																				BETSLIP_TYPE_SINGLE
																					? betSlip.unitStake
																					: betSlip.stake}
																			</span>
																		</li>
																	</ul>,
																	<ul key="2">
																		{!!Config.taxPercentOnStake && (
																			<>
																				<li>
																					<p className="possible-text-title-m">
																						{t(
																							"Tax on stake"
																						)}
																						{
																							": "
																						}
																						{
																							Config.taxPercentOnStake
																						}
																						{
																							"%"
																						}
																					</p>
																				</li>
																				<li>
																					<span className="sum-bet-win-price-m">
																						<MoneyAmount
																							amount={
																								((betSlip.freeBet
																									? Number.parseFloat(
																											betSlip.selectedFreeBetAmount
																									  ) ||
																									  0
																									: betSlip.type ===
																									  BETSLIP_TYPE_SINGLE
																									? betSlip.unitStake
																									: betSlip.stake) *
																									this
																										.props
																										.tax
																										.taxPercent) /
																								100
																							}
																						/>
																					</span>
																				</li>
																			</>
																		)}
																	</ul>,
																	<ul key="3">
																		<li>
																			<p className="possible-text-title-m">
																				{t(
																					"Total stake:"
																				)}
																			</p>
																		</li>
																		<li>
																			<span className="sum-bet-win-price-m">
																				<MoneyAmount
																					amount={
																						betSlip.freeBet
																							? Number.parseFloat(
																									betSlip.selectedFreeBetAmount
																							  ) ||
																							  0
																							: totalStakeWithoutTax
																					}
																				/>
																			</span>
																		</li>
																	</ul>,
																	<ul key="4">
																		<li>
																			<p className="possible-text-title-m">
																				{t(
																					"Possible win:"
																				)}
																			</p>
																		</li>
																		<li>
																			<span className="sum-bet-win-price-m">
																				<MoneyAmount
																					amount={
																						betSlip.type ===
																						BETSLIP_TYPE_SYSTEM
																							? systemPossibleWin
																							: posWinWithTax
																					}
																				/>
																			</span>
																		</li>
																	</ul>,
																	<ul key="5">
																		<li>
																			<p className="bonus-text-title-m">
																				{t(
																					"Accumulator Bonus"
																				)}
																			</p>
																		</li>
																		<li>
																			<span className="bonus-bet-win-price-m">
																				<MoneyAmount
																					amount={
																						expBonus
																					}
																				/>
																			</span>
																		</li>
																	</ul>,
																	<ul key="6">
																		{!systemOptions && (
																			<>
																				<li>
																					<p className="possible-text-title-m">
																						{t(
																							"Estimated return:"
																						)}
																					</p>
																				</li>
																				<li>
																					<span className="sum-bet-win-price-m">
																						<MoneyAmount
																							amount={
																								Config.estimatedReturnAndTotalWinCalculationChange
																									? posWinWithTax +
																									  (expBonus ||
																											0)
																									: posWin -
																									  Helpers.calculateTaxForReturnedAndProfit(
																											this
																												.props
																												.tax
																												?.taxPercent,
																											posWin +
																												expBonus,
																											this
																												.props
																												.partnerConfig
																												?.tax_amount_ranges ||
																												null
																									  )
																							}
																						/>
																					</span>
																				</li>
																			</>
																		)}
																	</ul>,
																	systemOptions &&
																		Config
																			.terminal
																			.showMinPossibleWin && (
																			<ul>
																				<li>
																					<p className="possible-text-title-m">
																						{"Min " +
																							t(
																								"possible win:"
																							)}
																					</p>
																				</li>
																				<li>
																					<span className="sum-bet-win-price-m">
																						{Config.enableCurrencyView && (
																							<span>
																								{
																									Config
																										.main
																										.currency[
																										currency
																									]
																								}
																							</span>
																						)}
																						{Math.trunc(
																							this.getSystemPossibleMin(
																								events,
																								sysOptionValue,
																								betSlip.type ===
																									BETSLIP_TYPE_SYSTEM
																									? totalStakeWithoutTax /
																											events.length
																									: betSlip.unitStake
																							) *
																								(1 -
																									this
																										.props
																										.tax
																										.taxPercent /
																										100) *
																								1000
																						) /
																							1000}
																					</span>
																				</li>
																			</ul>
																		),
																];

															default:
																// same as under array
																return [
																	<ul key="5">
																		<li>
																			<p className="possible-text-title-m">
																				{t(
																					"Possible win:"
																				)}
																			</p>
																		</li>
																		<li>
																			<span className="sum-bet-win-price-m">
																				<MoneyAmount
																					amount={
																						posWin
																					}
																				/>
																			</span>
																		</li>
																	</ul>,
																	betSlip.type ===
																		BETSLIP_TYPE_SINGLE && (
																		<ul>
																			<li>
																				<p className="possible-text-title-m">
																					{t(
																						"Total stake:"
																					)}
																				</p>
																			</li>
																			<li>
																				<span className="sum-bet-win-price-m">
																					<MoneyAmount
																						amount={Object.keys(
																							betSlip.events
																						)
																							.filter(
																								item =>
																									Object.prototype.hasOwnProperty.call(
																										betSlip.events,
																										item
																									)
																							)
																							.reduce(
																								(
																									sum,
																									item
																								) =>
																									sum +
																										parseFloat(
																											betSlip
																												.events[
																												item
																											]
																												.singleStake
																										) ||
																									0,
																								0
																							)}
																					/>
																				</span>
																			</li>
																		</ul>
																	),
																	systemOptions &&
																		Config
																			.terminal
																			.showMinPossibleWin && (
																			<ul>
																				<li>
																					<p className="possible-text-title-m">
																						{t(
																							"Min possible win"
																						)}

																						:
																					</p>
																				</li>
																				<li>
																					<span className="sum-bet-win-price-m">
																						{this.getSystemPossibleMin(
																							events,
																							sysOptionValue,
																							betSlip.unitStake
																						)}
																						{Config.enableCurrencyView && (
																							<span>
																								{
																									Config
																										.main
																										.currency[
																										currency
																									]
																								}
																							</span>
																						)}
																					</span>
																				</li>
																			</ul>
																		),
																];
														}
												  }.call(this)
												: [
														// checks if any of events has SP price
														<ul key="6">
															<li>
																<p className="possible-text-title-m">
																	{t(
																		"Possible win:"
																	)}
																</p>
															</li>
															<li>
																<span className="sum-bet-win-price-m">
																	<MoneyAmount
																		amount={
																			posWin
																		}
																	/>
																</span>
															</li>
														</ul>,
														betSlip.type ===
															BETSLIP_TYPE_SINGLE && (
															<ul>
																<li>
																	<p className="possible-text-title-m">
																		{t(
																			"Total stake:"
																		)}
																	</p>
																</li>
																<li>
																	<span className="sum-bet-win-price-m">
																		<MoneyAmount
																			amount={Object.keys(
																				betSlip.events
																			)
																				.filter(
																					item =>
																						Object.prototype.hasOwnProperty.call(
																							betSlip.events,
																							item
																						)
																				)
																				.reduce(
																					(
																						sum,
																						item
																					) =>
																						sum +
																							parseFloat(
																								betSlip
																									.events[
																									item
																								]
																									.singleStake
																							) ||
																						0,
																					0
																				)}
																		/>
																	</span>
																</li>
															</ul>
														),
														systemOptions &&
															Config
																.terminal
																.showMinPossibleWin && (
																<ul>
																	<li>
																		<p className="possible-text-title-m">
																			{t(
																				"Min possible win"
																			)}

																			:
																		</p>
																	</li>
																	<li>
																		<span className="sum-bet-win-price-m">
																			{this.getSystemPossibleMin(
																				events,
																				sysOptionValue,
																				betSlip.unitStake
																			)}
																			{Config.enableCurrencyView && (
																				<span>
																					{
																						Config
																							.main
																							.currency[
																							currency
																						]
																					}
																				</span>
																			)}
																		</span>
																	</li>
																</ul>
															),
												  ]}
											{Config.swapTaxAndBonus ? (
												<ul>
													<li>
														<p className="possible-text-title-m affaf">
															{t(
																"Tax on Return:"
															)}
														</p>
													</li>
													<li>
														<span className="sum-bet-win-price-m">
															<MoneyAmount
																amount={
																	returnTax
																}
															/>
														</span>
													</li>
												</ul>
											) : expBonus ? (
												<ul>
													<li>
														<p className="bonus-text-title-m">
															{!Config.betslipTextsCircus
																? t(
																		"Accumulator Bonus"
																  )
																: t(
																		"Boost"
																  )}
														</p>
													</li>
													<li>
														<span className="bonus-bet-win-price-m">
															<MoneyAmount
																amount={
																	expBonus
																}
															/>
														</span>
													</li>
												</ul>
											) : null}
											{expBonus ||
											Config.betting
												.showTotalWinWithoutBonus ? (
												<ul>
													<li>
														<p className="total-win-m">
															{!Config.betslipTextsCircus
																? t(
																		"Total win:"
																  )
																: t(
																		"Gain max"
																  )}
														</p>
													</li>
													<li>
														<span className="total-win-price-m">
															<MoneyAmount
																amount={
																	Config.estimatedReturnAndTotalWinCalculationChange
																		? betSlip.type ===
																		  BETSLIP_TYPE_SYSTEM
																			? systemPossibleWin -
																			  returnTax
																			: posWinWithTax +
																			  (expBonus ||
																					0) -
																			  Helpers.calculateTaxForReturnedAndProfit(
																					this
																						.props
																						.tax
																						?.taxPercent,
																					posWinWithTax +
																						(expBonus ||
																							0),
																					this
																						.props
																						.partnerConfig
																						?.tax_amount_ranges ||
																						null
																			  )
																		: posWin +
																		  (expBonus ||
																				0)
																}
															/>
														</span>
													</li>
												</ul>
											) : null}
										</div>
									) : null}
								</div>
							) : null}
							{/*free bet*/}
							{/* {
                            console.log(freeBetAvailable, "__________________________________________________________________")
                        } */}
							{freeBetAvailable &&
							!Config.main.disableFreeBet &&
							!betSlip.editBetMode
								? [
										<div
											key={"1"}
											className="bet-kind-container free-bet-container"
										>
											<div className="kind-of-bet freebet-icon" />
											<p className="freebet-text">
												{t("Free Bet")}
											</p>
											<div className="info-i-switcher-b freebet-s">
												<Expandable
													className="info-icon-k-bet"
													uiKey="freeBetInfo"
												/>
												<div
													className="switcher-box"
													onClick={
														this
															.toggleFreeBet
													}
												>
													<div
														className={
															"switcher-contain " +
															(betSlip.freeBet
																? "on"
																: "")
														}
													>
														<div className="switcher-circle-b-m" />
													</div>
												</div>
											</div>
										</div>,
										<div
											key={"2"}
											className={
												"text-info-kind-bet " +
												(this.props.persistentUI
													.expanded
													.freeBetInfo
													? "active"
													: "")
											}
										>
											<p>
												{t(
													"FreeBet allows placing a free bet(using your bonus balance) for selected sporting events."
												)}
											</p>
										</div>,
								  ]
								: null}
							{freeBetAvailable && betSlip.freeBet && !betSlip.editBetMode ? (
								<div className="free-bet-open-view">
									<ul>
										<li>
											<p>{t("Choose a stake:")}</p>
										</li>
										{betSlip.freeBetsList.map(
											freeBetItem => (
												<li>
													<div className="radio-form-item">
														<label
															onClick={this.selectFreeBet(
																freeBetItem.id,
																freeBetItem.amount
															)}
														>
															<input
																type="radio"
																value={
																	freeBetItem.amount
																}
																checked={
																	parseInt(
																		freeBetItem.id
																	) ===
																	parseInt(
																		betSlip.selectedFreeBetId
																	)
																}
																name="free-bet"
															/>
															<span>
																<MoneyAmount
																	amount={
																		freeBetItem.amount
																	}
																/>
															</span>
														</label>
													</div>
												</li>
											)
										)}
									</ul>
								</div>
							) : null}

							{/*free bet END*/}
							{["error", "warning", "info"].map(type =>
								displayInfo[type].map((message, i) => (
									<div
										key={i}
										className={"text-info-bet-m " + type}
									>
										<p>{t(message)}</p>
									</div>
								))
							)}

							{insufficientBalance &&
								Config.main.betslipAdditionalMessages &&
								Config.main.betslipAdditionalMessages[
									"insufficientBalance"
								] && (
									<div className={"text-info-bet-m warning"}>
										{getAdditionalMessage(
											Config.main
												.betslipAdditionalMessages[
												"insufficientBalance"
											]
										)}
									</div>
								)}

							{betSlip.betAccepted ? (
								<div className="text-info-bet-m accept">
									<p>{t("Bet accepted.")}</p>
									{betSlip.betAccepted.details.is_super_bet ? (
										<p>
											{t(
												"You will get notification about your super bet status soon."
											)}
										</p>
									) : null}
									<b onClick={this.resetBetslipStatus} />
								</div>
							) : null}
							{betSlip.betFailed ? (
								<div className="text-info-bet-m error">
									<p>{betSlip.betFailed.reason}</p>
								</div>
							) : null}
							{events.length > 1 &&
							events[0] &&
							events[0].marketDisplayKey === "OUTRIGHT" &&
							info.hasSingleOnlyEvents &&
							BetslipTypes[betSlip.type] !==
								BetslipTypes[BETSLIP_TYPE_SINGLE] ? (
								<div className="text-info-bet-m error">
									<p>{t("Incompatible events with outright")}</p>
								</div>
							) : null}
							{priceChangeNeeds2bConfirmed &&
							!Config.betslipAcceptAndPlaceOneButton ? (
								<div className="bet-button-container">
									<div className="separator-box-buttons-m acceptChanges">
										<button
											className="button-view-normal-m"
											onClick={this.acceptChanges}
										>
											{t("Accept Changes")}
										</button>
									</div>
								</div>
							) : null}

							{!this.props.ui.loading.bet ? (
								<div className="bet-button-container">
									{(!isRacingType &&
										isPartnerIntegration &&
										!this.props.user.profile) ||
									Config.disablePlaceBetButton ? (
										<div className="bet-button-container">
											<div className="separator-box-buttons-m">
												<button
													className="button-view-normal-m"
													onClick={() =>
														this.bookBet(
															posWin,
															expOdds
														)
													}
													disabled={
														Config.betslipAcceptAndPlaceOneButton
															? priceChangeNeeds2bConfirmed
															: !events.length ||
															  betsCannotBeBooked
													}
												>
													{t(
														"Get Booking Id"
													)}{" "}
													{
														this
															.props
															.ui
															.loading
															.getBookingBetId
													}
												</button>
											</div>
										</div>
									) : (
										<div>
											<div className="separator-box-buttons-m">
												{events.length >
													Config.eventsCountToShowBetslipClear &&
												Config.betslipClearAllButtonOnFooter ? (
													<li className="cleared-all-box">
														<div
															className="clear-all-m"
															onClick={
																this
																	.clearBetslip
															}
														>
															<span />
														</div>
													</li>
												) : null}
												{Config.enableRepeatBetButton &&
												this.props.betslip
													.lastBet &&
												isBetslipEmpty ? (
													<button
														className="button-view-normal-m repeat-bet-button"
														onClick={
															this
																.repeatBet
														}
													>
														{t(
															"Repeat Last Bet"
														)}
														{Config.repeatBetInterval && (
															<>
																{" "}
																(
																<CountDown
																	propsDefaultSecond={
																		Config.repeatBetInterval
																	}
																/>

																)
															</>
														)}
													</button>
												) : (
													<button
														className="button-view-normal-m"
														onClick={() =>
															priceChangeNeeds2bConfirmed &&
															Config.betslipAcceptAndPlaceOneButton
																? this.acceptChanges()
																: this.placeBet(
																		horseBetSlipLocalTypes.localBetslipHorseType
																  )
														}
														disabled={
															betsCannotBePlaced &&
															(!Config.betslipAcceptAndPlaceOneButton ||
																!priceChangeNeeds2bConfirmed)
														}
													>
														{t(
															priceChangeNeeds2bConfirmed &&
																Config.betslipAcceptAndPlaceOneButton
																? "Accept Changes"
																: "Place bet"
														)}
													</button>
												)}
											</div>
											{Config.betting
												.enableBookingBet &&
											bookingOnlyWithoutBalance &&
											!isRacingType ? (
												<div className="separator-box-buttons-m">
													<button
														className="button-view-normal-m"
														onClick={() =>
															this.bookBet(
																posWin,
																expOdds,
																horseBetSlipLocalTypes.localBetslipHorseType
															)
														}
														disabled={
															!events.length ||
															betsCannotBeBooked
														}
													>
														{t(
															"Get Booking Id"
														)}{" "}
														{
															this
																.props
																.ui
																.loading
																.getBookingBetId
														}
													</button>
												</div>
											) : null}
											{Config.betting
												.enableSuperBet &&
											!Config.betting
												.enableSuperBetAutomatically &&
											(!Config.superBetAfterStakeInput ||
												betSlip.type ===
													BETSLIP_TYPE_SINGLE) &&
											(Config.betting
												.allowSuperBetForLive ||
												(Object.keys(
													this.props
														.betslip
														.events
												).length !== 0 &&
													!Helpers.hasLiveGame(
														Object.values(
															this
																.props
																.betslip
																.events
														)
													))) ? (
												<div className="separator-box-buttons-m">
													<label
														htmlFor="superbet"
														className="multi-column-mode-toggle"
													>
														<input
															id="superbet"
															style={{
																position: "relative",
																left: 0,
																top: 0,
															}}
															type="checkbox"
															onClick={
																this
																	.toggleSuperBet
															}
															checked={
																(Config
																	.betting
																	.allowSuperBetForLive ||
																	!Helpers.hasLiveGame(
																		Object.values(
																			this
																				.props
																				.betslip
																				.events
																		)
																	)) &&
																!!this
																	.props
																	.betslip
																	.superBet
															}
														/>
														<p>
															Superbet
															is{" "}
															{this
																.props
																.betslip
																.superBet
																? "on"
																: "off"}
														</p>
													</label>
												</div>
											) : null}
										</div>
									)}
								</div>
							) : (
								<Loader component="betslip" withoutMessage={true} />
							)}
						</div>
					</div>
				) : (
					<div className="q-bet-container">
						{this.props.ui.opened.quickBetStake !== false ? (
							<div className="q-mini-box">
								<div className="quick-bet-form-m" key="quickBetStake">
									<ul>
										<li>
											<div className="single-form-item">
												{/*<input type="hidden" defaultValue={betSlip.stake} ref="quickBetStake" />*/}
												<span
													onClick={e => {
														if (
															!this
																.props
																.ui
																.showVirtualKeyBoard &&
															!betSlip.freeBet
														) {
															this.openKeyBoard(
																betSlip.stake,
																this
																	.setQuickBetStake,
																null,
																betSlip,
																e,
																this
																	.saveQuickBetStake
															);
														}
													}}
												>
													{betSlip.stake ||
														t(
															"Stake..."
														)}
												</span>
											</div>
										</li>
										<li>
											<div className="save-b-m">
												<button
													className="button-view-normal-m trans-m"
													onClick={
														this
															.saveQuickBetStake
													}
												>
													{t("Save")}
												</button>
											</div>
										</li>
									</ul>
								</div>
								<div className="text-info-bet-m" key="quickBetInfo">
									<p>{t("Click on any odd to place a bet.")}</p>
								</div>
							</div>
						) : null}
						{Object.keys(betSlip.quickBetNotifications).map(id => (
							<div
								key={id}
								className={
									"text-info-bet-m " +
									betSlip.quickBetNotifications[id].type
								}
							>
								<p>{betSlip.quickBetNotifications[id].msg}</p>
								<b onClick={this.resetBetslipStatus} />
							</div>
						))}
					</div>
				)}
				{Config.terminal.scrollButtons ? (
					<div className="scroll-b-view-w">
						<div className="single-s-b top-v" onClick={this.scroll(-80)} />
						<div className="single-s-b bot-v" onClick={this.scroll(80)} />
					</div>
				) : null}
				{
					<BetIdEnter
						hidden={
							!Config.ticketCheckBetSlip ||
							Object.getOwnPropertyNames(this.props.betslip.events).length !==
								0
						}
						setSelectionIds={data => {
							bookIdCheck(data)(this.props);
						}}
					/>
				}
			</div>
		</div>
	);
}
